'use client';

import { Box, Button, ButtonProps, Link, Stack, SxProps, Typography } from '@mui/material';
import { DisclosureTooltip } from '../DisclosureTooltip';

const DefaultDisclosureContent = () => {
  return (
    <>
      <Typography component="p" variant="text">
        We believe everyone should be able to make financial decisions with confidence. While we
        don&apos;t cover every company or financial product on the market, we work hard to share a
        wide range of offers and objective editorial perspectives.
      </Typography>
      <Typography component="p" variant="text">
        So how do we make money? Our partners compensate us for advertisements that appear on our
        site. This compensation helps us provide tools and services - like free credit score access
        and monitoring. With the exception of mortgage, home equity and other home-lending products
        or services, partner compensation is one of several factors that may affect which products
        we highlight and where they appear on our site. Other factors include your credit profile,
        product availability and proprietary website methodologies.
      </Typography>
      <Typography component="p" variant="text">
        However, these factors{' '}
        <Typography component="span" variant="textBold">
          do not influence our editors&apos; opinions or ratings
        </Typography>
        , which are based on independent research and analysis. Our partners cannot pay us to
        guarantee favorable reviews.{' '}
        <Link href="https://www.nerdwallet.com/p/our-partners">
          Here is a list of our partners.
        </Link>
      </Typography>
    </>
  );
};

const DisclosureContent = () => {
  const Content = DefaultDisclosureContent;
  return (
    <Stack
      spacing={3}
      sx={{
        marginBottom: 1,
      }}
    >
      <Typography
        component="h3"
        variant="textLargeBold"
        sx={{
          fontWeight: 700,
          color: 'primary.main',
        }}
      >
        <Box>You&apos;re our first priority.</Box>
        <Box>Every time.</Box>
      </Typography>
      <Content />
    </Stack>
  );
};

type Props = ButtonProps & {
  bold?: boolean;
  containerStyles?: SxProps;
  textColor?: string;
};

export const AdvertisingDisclosureButton = (props: Props) => {
  const {
    sx: sxProps,
    containerStyles,
    bold = false,
    textColor = 'secondary.main',
    ...rest
  } = props;
  return (
    <DisclosureTooltip
      tooltipStyleOverride={{ maxWidth: '578px', ...containerStyles }}
      trigger={
        <Button
          variant="text"
          fullWidth={false}
          disableRipple
          sx={{
            textTransform: 'none',
            padding: 0,
            '&:hover': {
              backgroundColor: 'transparent',
              '&  span': {
                textDecoration: 'underline',
              },
            },
            ...sxProps,
          }}
          {...rest}
        >
          <Typography
            variant="textSmall"
            sx={{
              fontWeight: bold ? 500 : 300,
              color: textColor,
            }}
          >
            Advertiser disclosure
          </Typography>
        </Button>
      }
    >
      <DisclosureContent />
    </DisclosureTooltip>
  );
};
